import { useCallback } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { GerenciadorPrecos } from '../../../../../@types/GerenciadorPrecos';
import { RootState } from '../../../../../@types/RootState';
import { ContextMenuItem } from '../../../../../components';
import { AlertWithTimestamp } from '../../../../../components/AlertWithTimestamp';
import { Exception } from '../../../../../data';
import { selectorDataPointsExhibitionType } from '../../../../../reducers';
import { selectorContextMenu } from '../../../../../reducers/gerenciadorPrecos/contextMenu';
import { UPDATE_GERENCIADOR_DATAPOINT_BY_ID, UpdateGerenciadorDatapointByIdPayload } from '../../../../../reducers/gerenciadorPrecos/datapoints';
import { mergeUndoneOfferDetails, undoEditedOfferDatapoint } from '../../services';
import { calcOfferDiscountPercentage } from '../ExpandedRowOffer/utils';

type RowData = GerenciadorPrecos.RowData;

type UndoOfferPriceChangesContextMenuProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const EDITED_PRICE_STATUS = /EDITADO|EDITED/;

export const isOfferPriceEdited = (offerDetails: RowData['offerDetails']) => !!offerDetails?.priceStatus?.match(EDITED_PRICE_STATUS);

const UndoOfferPriceChangesContextMenu = ({ contextMenuDatapoint, datapointsExibitionType, updateDatapointById }: UndoOfferPriceChangesContextMenuProps) => {
  const offerDetails = contextMenuDatapoint?.offerDetails;

  const handleUndoEditedOffer = useCallback(async () => {
    if (!contextMenuDatapoint || !offerDetails) return;

    const { productsToBePricedId, productId, storeId } = contextMenuDatapoint;

    try {
      const { status, data } = await undoEditedOfferDatapoint({
        productId,
        storeId,
        productFamilyId: offerDetails.productFamilyId,
        clusterId: offerDetails.clusterId,
        datapointExhibitionType: datapointsExibitionType ?? 'PRODUCT',
      });

      if (status !== 200) return;

      // O desconto devolvido é sobre o preço sugerido do regular; a grade mostra sobre o preço atual (IT-5331).
      const undoneOfferDetails = mergeUndoneOfferDetails(offerDetails, data);
      const discountPercentage = calcOfferDiscountPercentage(contextMenuDatapoint, undoneOfferDetails?.price ?? null);

      updateDatapointById({
        id: productsToBePricedId,
        data: { offerDetails: undoneOfferDetails && { ...undoneOfferDetails, discountPercentage } },
      });

      const { message } = new Exception('Alteração de preço desfeita com sucesso');
      AlertWithTimestamp({ message, type: 'success' });
    } catch {
      const { message } = new Exception('Erro ao desfazer alteração');
      AlertWithTimestamp({ message });
    }
  }, [contextMenuDatapoint, offerDetails, datapointsExibitionType, updateDatapointById]);

  if (!isOfferPriceEdited(offerDetails)) return null;

  return <ContextMenuItem onClick={handleUndoEditedOffer}>Desfazer alteração de preço</ContextMenuItem>;
};

const mapStateToProps = (state: RootState) => ({
  contextMenuDatapoint: selectorContextMenu(state),
  datapointsExibitionType: selectorDataPointsExhibitionType(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  updateDatapointById: (payload: UpdateGerenciadorDatapointByIdPayload) => dispatch(UPDATE_GERENCIADOR_DATAPOINT_BY_ID(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UndoOfferPriceChangesContextMenu);
